import { render, staticRenderFns } from "./BaseBannerAccount.vue?vue&type=template&id=05715b0c"
import script from "./BaseBannerAccount.vue?vue&type=script&lang=js"
export * from "./BaseBannerAccount.vue?vue&type=script&lang=js"
import style0 from "./BaseBannerAccount.vue?vue&type=style&index=0&id=05715b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports